import { useAuth } from '@app/hooks/useAuth';

export function ForbiddenPage() {
  const { logout } = useAuth();
  return (
    <div className="mx-auto mt-20 max-w-md text-center">
      <h1 className="text-xl font-semibold">Forbidden</h1>
      <p className="mt-2 text-sm text-gray-600">
        Your account is not authorized for the admin portal.
      </p>
      <button
        type="button"
        onClick={() => logout()}
        className="mt-4 rounded border px-3 py-1 text-sm"
      >
        Sign out
      </button>
    </div>
  );
}
